module.exports = __webpack_public_path__ + "newsletter/Components/PocketHitsSignup/images/publishers/logo-fastCompany.dc82b0f70987ae89c48b72e5afbe1e09.png";